export default "__VITE_ASSET__b8b45f3f__"